export const ArchivedShiftIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ fill = '#3F5169' }) => {
  return (
    <>
      <svg width="13" height="13" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.14285 16C10.2646 16 12.2994 15.1571 13.7997 13.6569C15.3 12.1566 16.1429 10.1217 16.1429 8C16.1429 5.87827 15.3 3.84344 13.7997 2.34315C12.2994 0.842855 10.2646 0 8.14285 0C6.02112 0 3.98629 0.842855 2.486 2.34315C0.985708 3.84344 0.142853 5.87827 0.142853 8C0.142853 10.1217 0.985708 12.1566 2.486 13.6569C3.98629 15.1571 6.02112 16 8.14285 16ZM8.14285 3.5C8.42723 3.5 8.6866 3.65938 8.81473 3.91563L12.0647 10.4156C12.2491 10.7875 12.0991 11.2375 11.7304 11.4219C11.3616 11.6062 10.9085 11.4562 10.7241 11.0875L10.1804 10H6.10848L5.56473 11.0844C5.38035 11.4563 4.93035 11.6062 4.55848 11.4187C4.1866 11.2312 4.0366 10.7844 4.2241 10.4125L7.4741 3.9125C7.60223 3.65937 7.8616 3.49688 8.14598 3.49688L8.14285 3.5ZM8.14285 5.92812L6.85535 8.5H9.42723L8.14285 5.92812Z"
          fill={fill}
        />
      </svg>
    </>
  );
};
